/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CleanupInputs */

const en_cleanup = /** @type {(inputs: CleanupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cleanup`)
};

const id_cleanup = /** @type {(inputs: CleanupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembersihan`)
};

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const es_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const fr_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const de_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const ja_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const zh_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const ar_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const it_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const ru_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const pt_cleanup = en_cleanup;

/** @type {(inputs: CleanupInputs) => LocalizedString} */
const ko_cleanup = en_cleanup;

/**
* | output |
* | --- |
* | "Cleanup" |
*
* @param {CleanupInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const cleanup = /** @type {((inputs?: CleanupInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CleanupInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cleanup(inputs)
	if (locale === "es") return es_cleanup(inputs)
	if (locale === "fr") return fr_cleanup(inputs)
	if (locale === "de") return de_cleanup(inputs)
	if (locale === "ja") return ja_cleanup(inputs)
	if (locale === "zh") return zh_cleanup(inputs)
	if (locale === "ar") return ar_cleanup(inputs)
	if (locale === "id") return id_cleanup(inputs)
	if (locale === "it") return it_cleanup(inputs)
	if (locale === "ru") return ru_cleanup(inputs)
	if (locale === "pt") return pt_cleanup(inputs)
	return ko_cleanup(inputs)
});